export enum TypeActeMedicalEPrescription {
  BIO = 'BIO', // Prescription d'actes de biologie médicale
  KINE = 'KINE', // Prescription d'actes de kinésithérapie
  INFIRMIER = 'INFIRMIER', // Prescription d'actes infirmiers
  PEDICURE = 'PEDICURE', // Prescription d'actes de pédicurie
  ORTHOPHONISTE = 'ORTHOPHONISTE', // Prescription d'actes d'orthophonie
  ORTHOPTISTE = 'ORTHOPTISTE', // Prescription d'actes d'orthoptie
  AUTRE = 'AUTRE', // Prescription hors périmètre du système e-prescription
}
